import { CreateOrderRateInterface, OrderRateInterface } from '../exports/Interfaces';
import { DataWrappedResponse } from '../exports/Types';
import BackendApiClient from './BackendApiClient';

class OrderRatesManager {
  public create = async (
    orderId: number,
    data: CreateOrderRateInterface,
  ): Promise<DataWrappedResponse<OrderRateInterface>> =>
    BackendApiClient.request({
      method: 'POST',
      url: `/orders/${orderId}/rates`,
      data,
    });
}

export default new OrderRatesManager();
